import { useMemo } from "react";
import AzureRolesView from "./AzureRolesView";

function AzureRoles({ configData, setConfigData, roles, formId }) {
  const rolesData = useMemo(() => {
    return configData.roles?.map((dataRole) => ({
      ...dataRole,
      role: roles.find((role) => role.id === dataRole.role_id) || null,
    }));
  }, [configData.roles, roles]);

  const availableRoles = useMemo(() => {
    const assignedRoleIds =
      configData.roles?.map((dataRole) => dataRole.role_id) || [];
    return roles.filter((role) => !assignedRoleIds.includes(role.id));
  }, [configData.roles, roles]);

  /**
   * This method will add a new role to the config data with the given role ID
   * @param {string} roleId
   */
  function onAddRole(roleId) {
    setConfigData((prevData) => ({
      ...prevData,
      roles: [
        ...(prevData.roles || []),
        {
          role_id: roleId,
          azure_group_id: "",
        },
      ],
    }));
  }

  /**
   * This method will remove the role with the given role ID from the config data
   * @param {string} roleId
   */
  function onDeleteRole(roleId) {
    setConfigData((prevData) => ({
      ...prevData,
      roles: prevData.roles.filter((role) => role.role_id !== roleId),
    }));
  }

  /**
   * This method will update the Azure group ID for the role with the given role ID in the config data
   * @param {string} roleId
   * @param {string} newAzureGroupId
   */
  function onAzureGroupIdChange(roleId, newAzureGroupId) {
    setConfigData((prevData) => ({
      ...prevData,
      roles: prevData.roles.map((role) =>
        role.role_id === roleId
          ? { ...role, azure_group_id: newAzureGroupId }
          : role,
      ),
    }));
  }

  return (
    <AzureRolesView
      rolesData={rolesData}
      availableRoles={availableRoles}
      onAddRole={onAddRole}
      onDeleteRole={onDeleteRole}
      onAzureGroupIdChange={onAzureGroupIdChange}
      formId={formId}
    />
  );
}

export default AzureRoles;
